import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router';

import { AuthLayout } from '@/shared/components/layouts/auth-layout/auth-layout';
import {
  LogoContainer,
  StyledLink,
} from '@/shared/components/layouts/auth-layout/auth-layout.styled';
import { LanguageSwitcher } from '@/shared/features/language-switcher/language-switcher';
import { ConditionalLogo } from '@/shared/features/theme-switcher/components/conditional-logo/conditional-logo';
import { ThemeSwitcher } from '@/shared/features/theme-switcher/components/theme-switcher';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const AuthRoot = () => {
  const { t } = useTranslation();
  const user = useAppSelector(selectUser);

  if (user) {
    return <Navigate to={'/'} replace />;
  }

  return (
    <AuthLayout
      header={
        <Stack
          flexDirection="row"
          padding="1.25rem 2.5rem"
          justifyContent="space-between"
          width="100%"
        >
          <LogoContainer>
            <StyledLink to="/">
              <ConditionalLogo />
            </StyledLink>
            {__IS_BACKOFFICE__ && (
              <Typography variant="h5">{t('backoffice:app_label')}</Typography>
            )}
          </LogoContainer>
          <Stack flexDirection="row" gap="1rem">
            <ThemeSwitcher />
            <LanguageSwitcher />
          </Stack>
        </Stack>
      }
    >
      <Outlet />
    </AuthLayout>
  );
};
